export default {
    queues: [],
};
